import { useState } from 'react';
import { useSelector } from 'react-redux';
import { taxSelectedSelector } from 'Store/modules/tax/selectors';
import { useFetchAmountResult } from 'Containers/Plans/components/CardPlan/ButtonPlan/hooks';
import { PlansType } from 'Types/common';
import {
  filterPlans,
  getRecommendedPlan,
  getReturnIncomePlans,
  initialState,
  ProductsObjectType,
  servicesInitialState,
  smartFilterResponse,
} from './utils';

export const useSmartFilter = ({
  plans,
}: {
  plans?: PlansType[];
}): smartFilterResponse | undefined => {
  const tax = useSelector(taxSelectedSelector);
  const { data } = useFetchAmountResult(!!tax?.recordId);
  const [variable, setVariable] = useState(initialState);
  const [products, setProducts] = useState(servicesInitialState);
  const { plansToRender, plansToRenderPremium } = filterPlans(plans, data);
  const updateProducts = (id: string): void => {
    const newProductState = Object.keys(products).reduce((acc, value) => {
      acc[value] = false;
      return acc;
    }, {} as ProductsObjectType);
    setProducts({
      ...newProductState,
      [id]: !products[id],
    });
  };

  const updateIncomes = (id): void => {
    setVariable(prev => ({
      ...prev,
      [id]: !variable[id],
    }));
  };

  if (Object.values(variable).includes(true) && plans) {
    const { isToRenderBasic, recommendedPlan } = getReturnIncomePlans(products, variable, plans);
    const plansToReturn = isToRenderBasic ? plansToRender : plansToRenderPremium?.reverse();
    return {
      plan: plansToReturn,
      isVip: false,
      planRecommended: recommendedPlan || undefined,
      stateFunctions: {
        updateIncomes,
        updateProducts,
        products,
        variable,
      },
    };
  }

  if (Object.values(products).includes(true) && plans) {
    const planRecomendedFilter = getRecommendedPlan(plans, products);
    return {
      plan: plansToRender,
      isVip: true,
      planRecommended: planRecomendedFilter ? planRecomendedFilter[0].name : undefined,
      stateFunctions: {
        updateIncomes,
        updateProducts,
        products,
        variable,
      },
    };
  }

  return {
    plan: plansToRender,
    isVip: false,
    planRecommended: undefined,
    stateFunctions: {
      updateIncomes,
      updateProducts,
      products,
      variable,
    },
  };
};
